import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class NfseService {
  urlGateway = environment.api_gateway;

  constructor(
    private http: HttpClient
  ) { }

  send(params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/orders/nfse/send/v1/`, params);
  }

  getStatus(ref): Observable<any> {
    return this.http.get<any>(`${this.urlGateway}/missions/${ref}`, {});
  }
}
